import React, { Component } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Button, Snackbar } from '@material-ui/core';
import { globalData, ADD, EDIT, VIEW, CHILD, NORMAL, SPOUSE, CLIENT, DRAFT, EMAIL } from '../../../../common/common';
import { egdeCollisions, deduplicationObjArr, newId } from '../../../../common/utils';
import EstateMenu from '../EstateMenu';
import EstateContent from './EstateContent';
import Alert from '@material-ui/lab/Alert';
import EstatePList from './EstatePList';
import AlertDialog from '../../../Layout/components/AlertDialog';

const Root = styled(Box)({
    width: '1300px',
    '& .menuWapper': {
        width: '20%',
        height: '100%',
        backgroundColor: '#FAFAFA',
    },
    '& .contentWapper': {
        width: '70%',
        height: '650px',
        padding: '24px',
        '& .cTop': {
            width: '100%',
            '& .pageTitle': {
                fontSize: '16px',
                fontWeight: 'bold',
                color: '#005E96',
            },
        },
        '& .cCenter': {
            width: '100%',
            overflowX: 'auto',
        },
        '& .cBottom': {
            width: '100%',
            '& .foot': {
                margin: '10px 0',
                '& .btn': {
                    width: '100px',
                    marginLeft: '10px',
                },
            },
        },
    },
    '& .listWapper': {
        width: '10%',
        height: '650px',
        backgroundColor: '#FAFAFA',
        overflowX: 'auto',
    },
    '& .line': {
        width: '100%',
        height: '1px',
        backgroundColor: '#A1A1A1',
        margin: '20px 0',
        opacity: '0.12',
    },
    '& .title': {
        fontSize: '18px',
        fontWeight: 'bold',
        color: '#212C31',
        marginTop: '18px',
    },
    '& .doc-type': {
        width: '200px',
        height: '26px',
        color: '#fff',
        fontSize: '12px',
        fontWeight: 'bold',
        borderRadius: '50px',
        backgroundColor: '#18C6FF'
    },
    '& .ml-10': {
        marginLeft: '10px'
    },
})

class EstateInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            menuData: [
                "DOCUMENT INFO",
                "FILLING-IN METHOD",
                "1. CLIENT’S GENERAL INFO",
                "2. CHILDREN",
                "3. EXECUTOR (CLIENT)",
                "4. GUARDIAN (CLIENT)",
                "5. GENERAL POWER OF ATTORNEY (CLIENT)",
                "6. HEALTH-CARE AGENT (CLIENT)",
                "7. LIVING WILL (CLIENT)",
                "WILL (CLIENT)",
                "FINAL DISPOSITION (CLIENT)",
                "8. HIPAA INFORMATION RELEASE FORM (CLIENT)",
                "9. EXECUTOR (SPOUSE)",
                "10. GUARDIAN (SPOUSE)",
                "11. GENERAL POWER OF ATTORNEY (SPOUSE)",
                "12. HEALTH-CARE AGENT (SPOUSE)",
                "13. LIVING WILL (SPOUSE)",
                "WILL (SPOUSE)",
                "FINAL DISPOSITION (SPOUSE)",
                "14. HIPAA INFORMATION RELEASE FORM (SPOUSE)",
                "15a. TRUSTEE",
                "15b. DISTRIBUTION OF TRUST",
                "16. EMERGENCY GUARDIAN",
            ],
            detailsData: [
                "DOCUMENT INFO",
                "FILLING-IN METHOD",
                "CLIENT’S GENERAL INFO",
                "List all living children.",
                "This person is responsible for handling your estate. Generally, the first choice is the spouse, followed by adult children, siblings, parents, friends, etc.",
                "This person who will assume guardianship of minor children until they turn 18 years old.",
                "This person will be responsible for taking care of your private affairs, business affairs, legal affairs, etc. should you be incapacitated.",
                "This person will be able to make medical decisions on your behalf should you become unconscious or otherwise be unable to do so on your own.",
                "This person will speak on your family’s behalf regarding medical decisions.",
                "WILL (CLIENT)",
                "FINAL DISPOSITION (CLIENT)",
                "These persons will be authorized to obtain your medical information and release it to doctors and other medical providers for your treatment.",
                "This person is responsible for handling your estate. Generally, the first choice is the spouse, followed by adult children, siblings, parents, friends, etc.",
                "This person who will assume guardianship of minor children until they turn 18 years old.",
                "This person will be responsible for taking care of your private affairs, business affairs, legal affairs, etc. should you be incapacitated.",
                "This person will be able to make medical decisions on your behalf should you become unconscious or otherwise be unable to do so on your own.",
                "This person will speak on your family’s behalf regarding medical decisions.",
                "WILL (SPOUSE)",
                "FINAL DISPOSITION (SPOUSE)",
                "These persons will be authorized to obtain your medical information and release it to doctors and other medical providers for your treatment.",
                "This person is responsible for the management and disposition of the trust’s assets. Placing assets in a trust helps to avoid probate and ensure that your estate is handled promptly and smoothly. For example, if you have investments or business interests, the trustee may make timely decisions as circumstances arise, without having to wait for the court’s probate proceedings. Other special requirements can also be accommodated, depending on your specific circumstances.",
                "The method to distribute the assets in the will (or in the trust): Generally,Trusts (or Wills) distribute assets according to the terms of the document, which can be to your direct descendants, to charities, or to other members of your family. By default,we recommend splitting assets equally amongst your children, or grandchildren if any. A specific consideration when completing this section should be how you would like to distribute your assets if you have no direct descendants (i.e. no children or grandchildren). Under law, if no designation is made, the assets will go to your parents if alive, and then to your siblings if any.Please indicate in this section how you would like your assets to be distributed in the event you do not have living children or grandchildren.",
                "EMERGENCY GUARDIAN",
            ],
            sendEmail: false,
            contentData: {},
            menuIndex: 0,
            offsetL: 0,
            offsetT: 0,
            dragData: null,
            prevState: false,
            showToast: false,
            pListData: [],
            epStatus: "",
            enduserFilled: false,
            showAlert: false,
        }
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleMenuIndex = this.handleMenuIndex.bind(this);
        this.handlePrev = this.handlePrev.bind(this);
        this.handleNext = this.handleNext.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.handleDown = this.handleDown.bind(this);
        this.handleMove = this.handleMove.bind(this);
        this.handleUp = this.handleUp.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.extractPList = this.extractPList.bind(this);
        this.updateInfoData = this.updateInfoData.bind(this);
        this.changeInputType = this.changeInputType.bind(this);
        this.handleSendEmail = this.handleSendEmail.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
    }
    render() {
        const {
            sendEmail,
            menuData,
            detailsData,
            menuIndex,
            showToast,
            offsetL,
            offsetT,
            dragData,
            pListData,
            epStatus,
            enduserFilled,
            showAlert,
        } = this.state;
        const { title, state, data } = this.props;
        const createBtn = () => {
            if (state === ADD && menuIndex === 0) {
                return <Button className="btn" variant="contained" color="primary" onClick={this.handleCreate}>create</Button>
            } else if (state === EDIT) {
                if (sendEmail && menuIndex === 1 && !enduserFilled) {
                    return <Button className="ml-10" variant="contained" color="primary" onClick={this.handleSendEmail}>send email</Button>
                } else if (menuIndex === menuData.length - 1) {
                    return <Button className="btn" variant="contained" color="primary" onClick={e => this.handleCreate(e, true)}>generate</Button>
                } else if (enduserFilled || !sendEmail) {
                    return <Button className="btn" variant="contained" color="primary" onClick={this.handleCreate}>save</Button>
                }
            }
        }
        const nextBtn = () => {
            if (state === EDIT) {
                if (sendEmail && menuIndex === 1 && !enduserFilled) {
                    return <div className="f"></div>
                } else {
                    return <div>
                        <Button disabled={this.isNext("prev")} className="btn" variant="contained" color="primary" onClick={this.handlePrev}>PREVIOUS</Button>
                        <Button disabled={this.isNext("next")} className="btn" variant="contained" color="primary" onClick={this.handleNext}>Next</Button>
                    </div>
                }
            } else {
                return <div className="f"></div>
            }
        }
        return (
            <Root id="estateInfo">
                <div className="h">
                    <div className="menuWapper">
                        <EstateMenu
                            menuData={menuData}
                            menuIndex={menuIndex}
                            isLock={this.isLock()}
                            epStatus={epStatus}
                            sendEmail={sendEmail}
                            state={state}
                            enduserFilled={enduserFilled}
                            // isLock={false}
                            handleMenuIndex={this.handleMenuIndex}
                        />
                    </div>
                    <div className="contentWapper v">
                        <div className="cTop">
                            <div className="pageTitle h h-bt">
                                <div>{title}</div>
                                <div className="doc-type c">MARRIED WITH CHILDREN</div>
                            </div>
                            <div className="line"></div>
                        </div>
                        <div className="cCenter f">
                            <EstateContent
                                menuData={menuData}
                                detailsData={detailsData}
                                contentData={data}
                                menuIndex={menuIndex}
                                state={state}
                                dragData={dragData}
                                handleChange={this.handleChange}
                                sendEmail={this.changeInputType}
                                epStatus={epStatus}
                                enduserFilled={enduserFilled}
                                ref={(child) => { this.estateContent = child }}
                            />
                        </div>
                        <div className="cBottom">
                            <div className="line"></div>
                            <div className="foot h h-bt">
                                {nextBtn()}
                                <div>
                                    <Button className="btn" variant="contained" onClick={this.handleCancel}>CANCEL</Button>
                                    {createBtn()}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="listWapper v">
                        <EstatePList
                            data={data}
                            offsetL={offsetL}
                            offsetT={offsetT}
                            pList={pListData}
                            updateInfoData={this.updateInfoData}
                            handleDown={this.handleDown}
                            handleUp={this.handleUp}
                            handleMove={this.handleMove}
                        />
                    </div>
                </div>
                <Snackbar anchorOrigin={{ vertical: "top", horizontal: "center" }} open={showToast} autoHideDuration={3000} onClose={this.handleClose}>
                    <Alert severity="warning">
                        {globalData.toastMsg}
                    </Alert>
                </Snackbar>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="All the entered information will be overwritten by your customer's inputtings. Are you sure to continue sending it?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        )
    }
    componentDidMount() {
        this.initGlobalData();
        const { state, data, epStatus } = this.props;
        const estateDom = document.getElementById("estateInfo");
        const offsetL = estateDom.getBoundingClientRect().left;
        const offsetT = estateDom.getBoundingClientRect().top;
        const sendEmail = epStatus === EMAIL ? true : false;
        const enduserFilled = this.getEnduserFilledStatus(data);
        let pListData = [];
        this.setState(() => ({
            offsetL,
            offsetT,
            epStatus,
            sendEmail,
            enduserFilled,
        }))
        if (state === ADD) {
            pListData = this.estateContent.getData();
        } else {
            pListData = data;
        }
        if (data) this.verifyClientsId(data, false);
        this.extractPList(pListData);
    }
    getEnduserFilledStatus(data) {
        const { epStatus } = this.props;
        if (data) {
            return (Object.keys(data.content).length > 0 && epStatus === EMAIL) ? true : false;
        } else {
            return false;
        }
    }
    componentDidUpdate(prevProps) {
        const { epStatus } = this.props;
        if (epStatus !== prevProps.epStatus) {
            const sendEmail = epStatus === EMAIL ? true : false;
            console.log("udpatae epStatus", epStatus, sendEmail)
            this.setState(() => ({
                epStatus,
                sendEmail,
            }));
        }
    }
    initGlobalData() {
        globalData.singleArr = [];
        globalData.dataINFO = {};
        globalData.sendEmail = false;
        globalData.sendEmailData = {};
    }
    //1.将所有user提取到一个arr，根据名字去重
    //2.没有id的user重新分配一个id
    //3.拿有id的arr与现有data进行比对，同名的user赋值id
    //hasId:旧数据没有id的自动添加id
    verifyClientsId(data, hasId = true) {
        const contentObj = data.content;
        if (Object.keys(data.content).length === 0) return;
        if (!contentObj.hasOwnProperty("INFOS")) {
            const infos = this.extractInfoToArr(contentObj["INFO"]);
            contentObj["INFOS"] = infos;
            console.log(infos);
        }
        const singleArr = this.extractSingleClient(contentObj, hasId);
        globalData.singleArr = singleArr;
        this.insertAttrToData(singleArr, contentObj);
    }
    extractInfoToArr(data) {
        //phone;unit;street;city;state;zipcode
        if (!data) return;
        if (Object.keys(data).length === 0) return;
        let addrObjP = data["P.H.Addr."];
        addrObjP["phone"] = data["P.H.Pho"];
        let addrObjS = data["S.H.Addr."];
        addrObjS["phone"] = data["S.H.Pho"];
        let rcP = (data["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
        let rcS = (data["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
        const arr = [{
            ".CHO.N.": data["S.F.Name"],
            ".CHO.R.C.": rcS,
            ".CHO.AddrNPho": addrObjS,
            "id": "2",
            "type": SPOUSE,
        }, {
            ".CHO.N.": data["P.F.Name"],
            ".CHO.R.C.": rcP,
            ".CHO.AddrNPho": addrObjP,
            "id": "1",
            "type": CLIENT,
        }]
        console.log(JSON.stringify(arr));
        return arr;
    }
    extractSingleClient(contentObj, hasId) {
        let allClientArr = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (!obj.hasOwnProperty("type")) {
                        if (obj.hasOwnProperty("P.H.Name") || this.isClient(obj)) {
                            obj["id"] = "1";
                            obj["type"] = CLIENT;
                        } else if (obj.hasOwnProperty("S.H.Name") || this.isSpouse(obj)) {
                            obj["id"] = "2";
                            obj["type"] = SPOUSE;
                        } else if (obj.hasOwnProperty("RC")) {
                            obj["type"] = CHILD;
                        } else {
                            obj["type"] = NORMAL;
                        }
                    }
                    // console.log(obj);
                    allClientArr.push(obj);
                }
            }
        }
        let singleArr = [];
        if (hasId) {
            singleArr = deduplicationObjArr(allClientArr, "id");
        } else {
            singleArr = deduplicationObjArr(allClientArr, ".CHO.N.");
            for (const obj of singleArr) {
                if (!obj.hasOwnProperty("id")) {
                    obj["id"] = newId();
                }
            }
        }
        console.log("singdArr", hasId, singleArr);
        return singleArr;
    }
    insertAttrToData(singleArr, contentObj) {
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    for (const singleObj of singleArr) {
                        if (singleObj.hasOwnProperty(".CHO.N.") && obj.hasOwnProperty(".CHO.N.")) {
                            if (singleObj[".CHO.N."] === obj[".CHO.N."]) {
                                obj["id"] = singleObj["id"];
                                obj["type"] = singleObj["type"];
                            }
                        }
                    }
                }
            }
        }
        console.log("end obj：", contentObj)
    }
    isClient(obj) {
        return obj["rc"] === "Spouse's" && (obj["relation"] === "Husband" || obj["relation"] === "Wife")
    }
    isSpouse(obj) {
        return obj["rc"] === "Client's" && (obj["relation"] === "Husband" || obj["relation"] === "Wife")
    }
    handleMenuIndex(index) {
        this.setState(() => ({
            menuIndex: index
        }))
    }
    handleNext() {
        const { menuIndex, enduserFilled, epStatus } = this.state;
        const doNext = this.estateContent.doNext();
        console.log(doNext);
        if (doNext) {
            // this.extractSpouseAndClient(menuIndex);
            let index = menuIndex + 1;
            if (epStatus === DRAFT && index === 1) index += 1;
            if (index === 9 || index === 17) index += 2;
            if (index === 2 && epStatus !== DRAFT) {
                if (!enduserFilled) this.props.handleManual();
            }
            this.setState(() => ({
                menuIndex: index
            }))
        } else {
            this.setState(() => ({
                showToast: true
            }))
        }
    }
    extractSpouseAndClient(menuIndex) {
        if (menuIndex === 1) {
            const data = this.estateContent.getData();
            const infoData = data.content["INFO"];
            const spouseInfo = {};
            const clientInfo = {};

            spouseInfo["id"] = infoData["id"];
            spouseInfo["type"] = infoData["type"];
            spouseInfo[".CHO.Em."] = infoData["S.Em"];
            spouseInfo[".CHO.N."] = infoData["S.F.Name"];
            spouseInfo[".CHO.AddrNPho"] = infoData["S.H.Addr."];
            spouseInfo[".CHO.Addr"] = infoData["S.H.Addr."];
            spouseInfo["S.H.Pho"] = infoData["S.H.Pho"];
            spouseInfo["S.W.Pho"] = infoData["S.W.Pho"];
            spouseInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Client's;Wife" : "Client's;Husband";
            spouseInfo["rc"] = "Client's";
            spouseInfo["relation"] = (infoData["P.SEX"] === "male") ? "Wife" : "Husband";
            globalData.spouseInfo = spouseInfo;

            clientInfo["id"] = infoData["id"];
            clientInfo["type"] = infoData["type"];
            clientInfo[".CHO.Em."] = infoData["P.Em"];
            clientInfo[".CHO.N."] = infoData["P.F.Name"];
            clientInfo[".CHO.AddrNPho"] = infoData["P.H.Addr."];
            clientInfo[".CHO.Addr"] = infoData["P.H.Addr."];
            clientInfo["P.H.Pho"] = infoData["P.H.Pho"];
            clientInfo["P.W.Pho"] = infoData["P.W.Pho"];
            clientInfo[".CHO.R.C."] = (infoData["P.SEX"] === "male") ? "Spouse's;Husband" : "Spouse's;Wife";
            clientInfo["rc"] = "Spouse's";
            clientInfo["relation"] = (infoData["P.SEX"] === "male") ? "Husband" : "Wife";
            globalData.clientInfo = clientInfo;
        }
    }
    handlePrev() {
        const { menuIndex, epStatus } = this.state;
        let index = menuIndex - 1;
        if (epStatus === DRAFT && index === 1) index -= 1;
        if (index === 10 || index === 18) index -= 2;
        this.setState(() => ({
            menuIndex: index
        }))
    }
    handleCreate(e, isDraft = false) {
        const { state } = this.props;
        const doNext = this.estateContent.doNext();
        if (doNext) {
            let obj = this.estateContent.getData();
            let contentObj = obj.content;
            this.rmSpouse(contentObj);
            console.log(obj)
            this.props.handleCreate(obj, isDraft);
            if (state !== EDIT) this.handleNext();
        } else {
            this.setState(() => ({
                showToast: true
            }))
        }
    }
    handleSendEmail() {
        const doNext = this.estateContent.doNext();
        if (doNext) {
            this.setState({
                showAlert: true,
            })
        } else {
            this.setState({
                showToast: true,
            })
        }
    }
    handleAlertYes() {
        this.closeAlertDialog();
        const doNext = this.estateContent.doNext();
        if (doNext) {
            this.estateContent.doSendEmail();
            const obj = this.estateContent.getData();
            globalData.sendEmail = true;
            this.props.handleSendEmail(obj);
        } else {
            this.setState(() => ({
                showToast: true,
            }))
        }
    }
    handleAlertNo() {
        this.closeAlertDialog();
    }
    closeAlertDialog() {
        this.setState({
            showAlert: false
        })
    }
    changeInputType() {
        this.setState({
            sendEmail: globalData.sendEmail
        })
    }
    handleCancel() {
        this.props.handleCancel();
    }
    handleClose() {
        this.setState(() => ({
            showToast: false
        }))
        globalData.toastMsg = "Please fill in the complete information";
    }
    handleDown() {
        this.setState({
            dragData: globalData.dragData
        }, () => {
            this.estateContent.handleDown();
        })
    }
    handleUp() {
        if (globalData.isCollision) {
            this.setState(() => ({
                dragData: globalData.dragData
            }))
        } else {
            this.setState(() => ({
                dragData: null
            }))
        }
        this.estateContent.handleUp();
    }
    handleMove(obj) {
        const { offsetL, offsetT, prevState } = this.state;
        let rect1 = obj;
        let rect2 = this.estateContent ? this.estateContent.getContentRectData() : null;
        if (!rect1 || !rect2) return;
        rect2.left -= offsetL;
        rect2.top -= offsetT;
        const isCollision = egdeCollisions(rect1, rect2);
        if (prevState !== isCollision) {
            globalData.isCollision = isCollision;
            this.setState(() => ({
                prevState: isCollision
            }));
            if (isCollision) {
                this.estateContent.handleCollision();
            } else {
                this.estateContent.handleLeave();
            }
        }
    }
    handleChange(name, value) {
        const data = this.estateContent.getData();
        if (name === 'D.T') return;
        this.extractPList(data, name, value);
        this.verifyClientsId(data);
    }
    extractPList(data, name, value) {
        if (!data) return [];
        const contentObj = data.content;
        if (contentObj["INFO"]) globalData.dataINFO = contentObj["INFO"];
        let pList = [];
        for (const key in contentObj) {
            const objArr = contentObj[key];
            if (objArr instanceof Array) {
                for (const obj of objArr) {
                    if (obj.hasOwnProperty(".CHO.N.")) {
                        if (obj[".CHO.N."].trim()) {
                            if (!obj.hasOwnProperty(".CHO.Em.")) obj[".CHO.Em."] = "";
                            pList.push(obj);
                        }
                    }
                    if (obj.hasOwnProperty("N.")) {
                        if (obj["N."].trim()) {
                            obj[".CHO.N."] = obj["N."];
                            obj[".CHO.AddrNPho"] = obj["AddrNPho"];
                            obj["rc"] = obj["rc"] ? obj["rc"] : "Our";
                            obj["relation"] = obj["relation"] !== "" ? obj["relation"] : obj["RC"];
                            obj[".CHO.R.C."] = obj["rc"] + ";" + obj["RC"];
                            pList.push(obj);
                        }
                    }
                }
            }
        }
        const emailArr = this.extractEmailArr(pList);
        const newEmailArr = deduplicationObjArr(emailArr, ".CHO.N.");
        let pListData = deduplicationObjArr(pList, "id");
        let arr = [];
        if (value) {
            arr = value;
        } else {
            arr = newEmailArr;
        }
        if (arr.length > 0) {
            for (const obj1 of pListData) {
                for (const obj2 of arr) {
                    if (obj1.hasOwnProperty(".CHO.Em.") && obj2.hasOwnProperty(".CHO.Em.")) {
                        if (obj1[".CHO.N."] === obj2[".CHO.N."]) {
                            obj1[".CHO.Em."] = obj2[".CHO.Em."];
                        }
                    }
                }
            }
        }
        console.log("pListData", pListData)
        this.setState({
            pListData
        })
    }
    extractEmailArr(data) {
        let arr = [];
        for (const obj of data) {
            if (obj.hasOwnProperty(".CHO.Em.")) {
                if (obj[".CHO.Em."] !== "") {
                    arr.push(obj);
                }
            }
        }
        return arr;
    }
    updateInfoData(panelData) {
        const type = panelData.type;
        if (type === CHILD || type === NORMAL) {
            this.estateContent.uploadChildNormalToAllData(panelData);
        } else {
            this.setDataInfo(panelData, (dataINFO) => {
                this.estateContent.setToAllData("INFO", dataINFO, () => {
                    this.estateContent.updateInfoToAllData();
                });
            });
        }
    }
    setDataInfo(panelData, callback = null) {
        const dataINFO = globalData.dataINFO;
        for (const key in panelData) {
            if (Object.hasOwnProperty.call(panelData, key)) {
                for (const key2 in dataINFO) {
                    if (Object.hasOwnProperty.call(dataINFO, key2)) {
                        if (key === key2) {
                            dataINFO[key2] = panelData[key];
                        }
                    }
                }
            }
        }
        if (callback) callback(dataINFO);
    }
    rmSpouse(contentObj) {
        for (const key in contentObj) {
            if (contentObj.hasOwnProperty(key)) {
                const element = contentObj[key];
                if (this.rmSpouseKey(key)) {
                    element.shift();
                }
            }
        }
    }
    rmSpouseKey(key) {
        if (key === "Ex") {//3
            return false;
        } else if (key === "Gu") {//4
            return true;
        } else if (key === "POA") {//5
            return false;
        } else if (key === "C.W.S.P.R") {//8
            return false;
        } else if (key === "C.F.S.P.R") {//9
            return false;
        } else if (key === "S.Ex") {//11
            return false;
        } else if (key === "S.Gu") {//12
            return true;
        } else if (key === "S.POA") {//13
            return false;
        } else if (key === "S.W.S.P.R") {//16
            return false;
        } else if (key === "S.F.S.P.R") {//17
            return false;
        } else if (key === "TRUSTEE") {//19
            return false;
        } else {
            return false;
        }
    }
    isNext(type) {
        const {
            menuData,
            menuIndex,
        } = this.state;
        if (type === "next") {
            return (menuIndex >= menuData.length - 1);
        } else if (type === "prev") {
            return (menuIndex <= 0);
        }
    }
    isLock() {
        const { state, epStatus } = this.props;
        if (state === ADD || epStatus !== DRAFT) {
            return true;
        } else {
            return false;
        }
    }
    isDisabled() {
        const { state } = this.props;
        if (state === ADD) {
            return false;
        } else if (state === VIEW) {
            return true;
        } else if (state === EDIT) {
            return false;
        }
    }
}

export default EstateInfo;